import(/* webpackMode: "eager" */ "/src/clients/web/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/src/clients/web/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/src/clients/web/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\"],\"variable\":\"--inter-font\",\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/src/app/speculation-rules.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/src/app/web-vitals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/src/components/linkedin-insight-tag/linkedin-insight-tag.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/src/components/loading-page/loading-page.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/src/components/navigation-events.ts");
;
import(/* webpackMode: "eager" */ "/src/clients/web/src/components/popup/cookies-popup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RedditPixelProvider"] */ "/src/clients/web/src/contexts/reddit-pixel.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/src/modules/_app/ToastManager.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/src/modules/_app/update-history.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/src/styles/global.scss");
